import { styled } from "@mui/material/styles";
import {
  Box,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  SelectChangeEvent,
  TextField,
} from "@mui/material";

export const StyledFormControl = styled(FormControl)(({ theme }) => ({
  width: "100%",
  "& .MuiOutlinedInput-root": {
    borderRadius: 8,
    backgroundColor: "#FFFFFF",
    fontSize: 14,
    marginTop: 5,
  },
  "& .MuiInputBase-input": {
    padding: "0.725rem 0.875rem",
  },
  "& .MuiInputLabel-root": {
    fontSize: 14,
    backgroundColor: "#FFFFFF",
    paddingRight: 2,
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#CFCFCF",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "#3A1C73",
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#3A1C73",
  },
}));

export const StyledTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: 8,
    backgroundColor: "#FFFFFF",
    fontSize: 14,
  },
  "& .MuiInputBase-input": {
    padding: "0.725rem 0.875rem",
  },
  "& .MuiInputLabel-root": {
    fontSize: 14,
    backgroundColor: "#FFFFFF",
    paddingRight: 2,
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#CFCFCF",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "#3A1C73",
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#3A1C73",
  },
  "& .MuiFormHelperText-root": {
    fontSize: "13px",
  },
  "& .MuiFormHelperText-contained": {
    fontSize: "13px",
  },
  "& .Mui-error": {
    fontSize: "13px", // Specific to error state
  },
}));
